import { render, staticRenderFns } from "./word_editoradd.vue?vue&type=template&id=7188405a&scoped=true&"
import script from "./word_editoradd.vue?vue&type=script&lang=js&"
export * from "./word_editoradd.vue?vue&type=script&lang=js&"
import style0 from "./word_editoradd.vue?vue&type=style&index=0&id=7188405a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188405a",
  null
  
)

export default component.exports